import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconOpenlinkOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M24.333 6.667a1 1 0 0 1 1 1v12.666a1 1 0 0 1-2 0V10.081L8.707 24.707a1 1 0 0 1-1.414-1.414L21.919 8.667H11.667a1 1 0 1 1 0-2z" /></svg>;
export default SvgIconOpenlinkOutlined;